<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
 
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { ConfigProvider } from 'ant-design-vue'
moment.locale('zh-cn')
export default {
  data() {
    return {
      locale: zhCN,
    }
  },
  components: {
    'a-config-provider': ConfigProvider,
  },
}
</script>

<style lang="less" >
* {
  margin: 0;
  padding: 0;
}
body,
html {
  width: 100%;
  height: 100%;
}
#app {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}
</style>